(function () {
  function parseJsonScript(node) {
    if (!node) {
      return null;
    }

    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function quizCaseFor(rules, damage, nails) {
    var found = null;

    if (!rules || !rules.length) {
      return {};
    }

    rules.forEach(function (rule) {
      if (rule && rule.damage === damage && rule.nails === nails) {
        found = rule;
      }
    });

    return found || {};
  }

  function renderPenRow(row, count, src) {
    var html = "";
    var i;

    if (!row) {
      return;
    }

    if (!src || count < 1) {
      row.innerHTML = "";
      return;
    }

    for (i = 0; i < count; i += 1) {
      html += '<img src="' + src + '" alt="">';
    }

    row.innerHTML = html;
  }

  function fillSupplyCard(card, pack, penSrc) {
    var pens;

    if (!card) {
      return;
    }

    if (!pack) {
      card.hidden = true;
      card.classList.remove("is-selected");
      card.removeAttribute("data-variant-id");
      return;
    }

    pens = Number(pack.pens) || 0;
    card.hidden = false;
    card.dataset.variantId = String(pack.id || "");
    card.dataset.available = pack.available === false ? "false" : "true";

    if (card.querySelector("[data-supply-title]")) {
      card.querySelector("[data-supply-title]").textContent =
        (Number(pack.days) || 0) + " day supply";
    }

    if (card.querySelector("[data-supply-meta]")) {
      card.querySelector("[data-supply-meta]").textContent =
        pens + (pens === 1 ? " pen" : " pens");
    }

    if (card.querySelector("[data-supply-price]")) {
      card.querySelector("[data-supply-price]").textContent = pack.price_formatted || "";
    }

    renderPenRow(card.querySelector("[data-supply-pens]"), pens, penSrc || pack.image || "");
  }

  function selectedValue(group) {
    var input = group ? group.querySelector("input[type='radio']:checked") : null;
    return input ? input.value : "";
  }

  function addStoryPackToCart(variantId, button) {
    var drawer;
    var cartPath;
    var payload;
    var idleLabel = button ? button.getAttribute("data-cta-idle") || button.textContent : "";

    if (!variantId) {
      return;
    }

    payload = {
      id: Number(variantId),
      quantity: 1,
    };

    drawer = document.querySelector("[data-cart-drawer-root]");
    cartPath = (window.__glowRoutes && window.__glowRoutes.cartUrl) || "/cart";

    if (drawer && drawer.dataset.sectionId) {
      payload.sections = drawer.dataset.sectionId;
      payload.sections_url = cartPath.startsWith("/") ? cartPath : "/" + cartPath;
    }

    if (button) {
      button.disabled = true;
      button.textContent = "Adding...";
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error("Add to cart failed");
        }

        return res.json();
      })
      .then(function (data) {
        if (data.sections && window.cartUi && window.cartUi.applyBundledSections) {
          window.cartUi.applyBundledSections(data.sections);
        }

        if (window.cartUi) {
          if (window.cartUi.syncCartCountFromApi) {
            window.cartUi.syncCartCountFromApi();
          }

          if (window.cartUi.openDrawer && (!window.cartUi.isDrawerOpen || !window.cartUi.isDrawerOpen())) {
            window.cartUi.openDrawer();
          }
        }
      })
      .catch(function (err) {
        console.error("Story quiz add to cart error:", err);
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          button.textContent = idleLabel;
        }
      });
  }

  function initStoryQuiz(quiz) {
    var steps = quiz.querySelectorAll("[data-quiz-step]");
    var rules = parseJsonScript(quiz.querySelector("[data-story-quiz-rules]")) || [];
    var penSrc = quiz.getAttribute("data-pen-src") || "";
    var cta = quiz.parentElement ? quiz.parentElement.querySelector("[data-story-quiz-atc]") : null;
    var ctaIdle = quiz.getAttribute("data-cta-idle") || (cta ? cta.textContent : "");

    if (cta) {
      cta.setAttribute("data-cta-idle", ctaIdle);
    }

    function showStep(n) {
      steps.forEach(function (step) {
        var index = parseInt(step.getAttribute("data-quiz-step"), 10);

        if (index === n) {
          step.removeAttribute("hidden");
        } else {
          step.setAttribute("hidden", "");
        }
      });
    }

    function clearStep(stepEl) {
      stepEl.querySelectorAll(".is-selected").forEach(function (item) {
        item.classList.remove("is-selected");
      });
      stepEl.querySelectorAll("input[type='radio']").forEach(function (input) {
        input.checked = false;
      });
    }

    function clearAfter(n) {
      steps.forEach(function (step) {
        var index = parseInt(step.getAttribute("data-quiz-step"), 10);

        if (index > n) {
          clearStep(step);
        }
      });
    }

    function setCtaVariant(variantId, available) {
      if (!cta) {
        return;
      }

      if (!variantId || available === false) {
        cta.disabled = true;
        cta.removeAttribute("data-variant-id");
        cta.textContent = ctaIdle;
        return;
      }

      cta.disabled = false;
      cta.setAttribute("data-variant-id", String(variantId));
    }

    function renderSupply() {
      var damageGroup = quiz.querySelector("[data-quiz-group='damage']");
      var nailsGroup = quiz.querySelector("[data-quiz-group='nails']");
      var damage = selectedValue(damageGroup);
      var nails = selectedValue(nailsGroup);
      var map = quizCaseFor(rules, damage, nails);
      var fullPack = map.full || null;
      var firstPack = map.first || null;
      var supply = quiz.querySelector(".story-supply");

      fillSupplyCard(quiz.querySelector("[data-supply-role='full']"), fullPack, penSrc);
      fillSupplyCard(quiz.querySelector("[data-supply-role='first']"), firstPack, penSrc);

      if (supply) {
        supply.classList.toggle("is-single", Boolean(fullPack) !== Boolean(firstPack));
      }

      setCtaVariant("", true);
    }

    function advanceFrom(stepEl) {
      var current = parseInt(stepEl.getAttribute("data-quiz-step"), 10);
      var next;

      if (current !== 1 && current !== 2) {
        return;
      }

      clearAfter(current);

      if (current === 2) {
        renderSupply();
      }

      showStep(current + 1);
      next = quiz.querySelector("[data-quiz-step='" + (current + 1) + "']");

      if (next) {
        next.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }

    quiz.querySelectorAll("[data-quiz-group]").forEach(function (group) {
      group.addEventListener("change", function (event) {
        var input = event.target.closest("input[type='radio']");
        var option;
        var stepEl;
        var available;

        if (!input) {
          return;
        }

        group.querySelectorAll(".is-selected").forEach(function (item) {
          item.classList.remove("is-selected");
        });

        option = input.closest("label");

        if (option) {
          option.classList.add("is-selected");
        }

        stepEl = group.closest("[data-quiz-step]");

        if (group.getAttribute("data-quiz-group") === "supply") {
          available = option && option.getAttribute("data-available") !== "false";
          setCtaVariant(option ? option.getAttribute("data-variant-id") : "", available);
          return;
        }

        if (stepEl) {
          advanceFrom(stepEl);
        }
      });

      group.addEventListener("click", function (event) {
        var label = event.target.closest("label");
        var input = label ? label.querySelector("input[type='radio']") : null;
        var stepEl;

        if (!input || !input.checked || group.getAttribute("data-quiz-group") === "supply") {
          return;
        }

        stepEl = group.closest("[data-quiz-step]");

        if (stepEl) {
          advanceFrom(stepEl);
        }
      });
    });

    quiz.querySelectorAll("[data-quiz-back]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = parseInt(btn.getAttribute("data-quiz-back"), 10);

        clearAfter(target);
        setCtaVariant("", true);
        showStep(target);
      });
    });

    if (cta) {
      cta.addEventListener("click", function () {
        addStoryPackToCart(cta.getAttribute("data-variant-id"), cta);
      });
    }
  }

  document.querySelectorAll("[data-story-quiz]").forEach(initStoryQuiz);

  function syncMuteUi(slide, video) {
    var mute = slide.querySelector(".story-videos__mute");

    slide.classList.toggle("is-muted", video.muted);

    if (mute) {
      mute.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
    }
  }

  function pauseVideoSlide(slide, reset) {
    var video;

    if (!slide) {
      return;
    }

    video = slide.querySelector(".story-videos__video");
    slide.classList.remove("is-playing");

    if (!video) {
      return;
    }

    video.pause();

    if (reset === false || video.readyState < 1) {
      return;
    }

    try {
      video.currentTime = slide.classList.contains("story-videos__slide--preview") ? 0.1 : 0;
    } catch (err) {}
  }

  function pauseOtherVideos(current) {
    document.querySelectorAll(".story-videos__slide.is-playing").forEach(function (slide) {
      if (slide !== current) {
        pauseVideoSlide(slide);
      }
    });
  }

  function playVideoSlide(slide) {
    var video = slide.querySelector(".story-videos__video");
    var src = (slide.getAttribute("data-video-src") || "").trim();
    var playPromise;

    if (!video || !src) {
      return;
    }

    if (!video.getAttribute("src")) {
      video.src = src;
    }

    pauseOtherVideos(slide);
    slide.classList.add("is-playing");
    syncMuteUi(slide, video);
    playPromise = video.play();

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function bindVideoSlide(slide) {
    var video;
    var mute;

    if (slide.dataset.storyVideoBound === "true") {
      return;
    }

    slide.dataset.storyVideoBound = "true";
    video = slide.querySelector(".story-videos__video");
    mute = slide.querySelector(".story-videos__mute");

    slide.addEventListener("click", function (event) {
      if (event.target.closest(".story-videos__mute")) {
        return;
      }

      event.preventDefault();

      if (slide.classList.contains("is-playing") && video && !video.paused) {
        pauseVideoSlide(slide, false);
        return;
      }

      playVideoSlide(slide);
    });

    if (mute && video) {
      mute.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        video.muted = !video.muted;
        syncMuteUi(slide, video);
      });
    }

    if (!video) {
      return;
    }

    syncMuteUi(slide, video);

    video.addEventListener("ended", function () {
      pauseVideoSlide(slide);
    });

    if (slide.classList.contains("story-videos__slide--preview")) {
      video.addEventListener("loadeddata", function () {
        if (slide.classList.contains("is-playing") || video.currentTime > 0) {
          return;
        }

        try {
          video.currentTime = 0.1;
        } catch (err) {}
      });
    }
  }

  function bindVideoSlides(root) {
    (root || document).querySelectorAll(".story-videos__slide").forEach(bindVideoSlide);
  }

  bindVideoSlides();

  if (typeof Swiper === "undefined") {
    return;
  }

  function markVideoSides(swiper) {
    var activeEl = swiper.slides[swiper.activeIndex];
    var activeCenter;

    if (!activeEl) {
      return;
    }

    activeCenter = activeEl.getBoundingClientRect().left + activeEl.offsetWidth / 2;

    swiper.slides.forEach(function (slideEl) {
      var center;

      slideEl.classList.remove("is-before", "is-after");

      if (slideEl === activeEl) {
        return;
      }

      center = slideEl.getBoundingClientRect().left + slideEl.offsetWidth / 2;
      slideEl.classList.add(center < activeCenter ? "is-before" : "is-after");
    });
  }

  document.querySelectorAll(".story-videos__swiper").forEach(function (el) {
    new Swiper(el, {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 14,
      loop: true,
      initialSlide: 2,
      speed: 450,
      grabCursor: true,
      on: {
        afterInit: function () {
          bindVideoSlides(this.el);
          markVideoSides(this);
        },
        slideChangeTransitionStart: function () {
          markVideoSides(this);
          pauseOtherVideos(null);
        },
        resize: markVideoSides,
      },
    });
  });

  document.querySelectorAll("[data-story-gallery]").forEach(function (gallery) {
    var thumbsEl = gallery.querySelector(".story-gallery__thumbs");
    var mainEl = gallery.querySelector(".story-gallery__main");
    var thumbs;

    if (!thumbsEl || !mainEl || !mainEl.querySelector(".swiper-slide")) {
      return;
    }

    thumbs = new Swiper(thumbsEl, {
      slidesPerView: "auto",
      spaceBetween: 8,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
    });

    new Swiper(mainEl, {
      spaceBetween: 0,
      navigation: {
        nextEl: gallery.querySelector(".story-gallery__nav--next"),
        prevEl: gallery.querySelector(".story-gallery__nav--prev"),
      },
      thumbs: {
        swiper: thumbs,
      },
    });
  });

  document.querySelectorAll(".story-table-wrap--compare").forEach(function (wrap) {
    var thumb = wrap.querySelector(".story-table-wrap__thumb");

    function updateTableBar() {
      var track = wrap.clientWidth;
      var total = wrap.scrollWidth;
      var max = total - track;
      var thumbWidth;

      if (!thumb || total <= 0) {
        return;
      }

      thumbWidth = Math.max(52, (track / total) * track);
      thumb.style.width = thumbWidth + "px";
      thumb.style.transform =
        max > 0 ? "translateX(" + (wrap.scrollLeft / max) * (track - thumbWidth) + "px)" : "translateX(0)";
    }

    wrap.addEventListener("scroll", updateTableBar, { passive: true });
    window.addEventListener("resize", updateTableBar);
    updateTableBar();
  });
})();
